var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFormComplete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Form_complete",
    clipPath: "url(#clip0_1232_23581)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.00033 1.33203L8.07833 1.3367C8.22714 1.35425 8.3657 1.42142 8.47165 1.52737C8.57761 1.63333 8.64478 1.77189 8.66233 1.9207L8.66699 1.9987V4.66536L8.67033 4.76536C8.69418 5.08281 8.83083 5.38125 9.05557 5.60672C9.2803 5.83219 9.57829 5.96981 9.89566 5.9947L10.0003 5.9987H12.667L12.745 6.00336C12.8938 6.02091 13.0324 6.08808 13.1383 6.19404C13.2443 6.29999 13.3114 6.43855 13.329 6.58736L13.3337 6.66536V12.6654C13.3337 13.1755 13.1388 13.6664 12.7888 14.0375C12.4388 14.4087 11.9603 14.6321 11.451 14.662L11.3337 14.6654H4.66699C4.15685 14.6654 3.66598 14.4705 3.29482 14.1205C2.92365 13.7705 2.70025 13.292 2.67033 12.7827L2.66699 12.6654V3.33203C2.66696 2.82189 2.86188 2.33102 3.21185 1.95986C3.56182 1.58869 4.0404 1.36529 4.54966 1.33536L4.66699 1.33203H8.00033Z",
    fill: "#97C9F9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M12.6664 4.66733H9.99969L9.99902 2L12.6664 4.66733Z",
    fill: "#97C9F9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1232_23581"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFormComplete);
export default __webpack_public_path__ + "static/media/form-complete.e0cec48d5644e85cc9b2e9f9914aca88.svg";
export { ForwardRef as ReactComponent };